/**
 * Transfer booking pricing constants and calculation.
 *
 * For transfers, each fleet has:
 * - basePrice: covers up to TRANSFER_BASE_KM (5 km).
 * - pricePerKm: charged for any additional distance beyond 5 km.
 *
 * Pricing Formula:
 * - If actual distance <= 5 km:
 *     price = basePrice
 * - If actual distance > 5 km:
 *     price = basePrice + (actual distance - 5) * pricePerKm
 */

export const TRANSFER_BASE_KM = 5

/**
 * Calculates transfer price for a given distance:
 * basePrice + (max(0, distanceKm - 5) * pricePerKm)
 */
export function calculateTransferPrice(
  basePrice: number = 0,
  pricePerKm: number = 0,
  distanceKm: number = 0
): number {
  const safeBase = Number(basePrice) || 0
  const safeRate = Number(pricePerKm) || 0
  const safeDist = Number(distanceKm) || 0

  const extraKm = Math.max(0, safeDist - TRANSFER_BASE_KM)
  return Math.round(safeBase + safeRate * extraKm)
}
